import { motion } from "framer-motion";

const platforms = [
  "Meta",
  "Instagram",
  "Facebook",
  "WhatsApp",
  "Google",
  "YouTube",
  "TikTok",
  "X / Twitter",
  "Snapchat",
  "LinkedIn",
];

export const Network = () => {
  return (
    <section
      data-testid="network-section"
      className="border-b border-border bg-background"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start"
        >
          <div className="lg:col-span-4">
            <span className="font-code text-xs uppercase tracking-[0.2em] text-accent">
              [ 00 ] — Network
            </span>
            <h2 className="font-display font-bold tracking-tight leading-none text-3xl sm:text-4xl mt-4">
              Experience across the platforms that matter.
            </h2>
          </div>

          <div className="lg:col-span-8">
            <p className="font-body text-muted-foreground leading-relaxed max-w-2xl mb-8">
              Years of hands-on work with account issues across every major
              social platform — including direct experience collaborating with
              employees at <span className="text-foreground font-medium">Meta</span>,{" "}
              <span className="text-foreground font-medium">Google</span>, and
              other platform support teams. Trusted by public figures,
              creators, and businesses handling sensitive account situations.
            </p>

            <div className="flex flex-wrap gap-2">
              {platforms.map((p) => (
                <span
                  key={p}
                  data-testid={`platform-chip-${p.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
                  className="font-code text-xs uppercase tracking-[0.15em] text-muted-foreground border border-border px-4 py-2 hover:text-foreground hover:border-accent transition-colors duration-200"
                >
                  {p}
                </span>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Network;
